var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64645 7.64645C7.84171 7.45118 8.15829 7.45118 8.35355 7.64645L12 11.2929L15.6464 7.64645C15.8417 7.45118 16.1583 7.45118 16.3536 7.64645C16.5488 7.84171 16.5488 8.15829 16.3536 8.35355L12.7071 12L16.3536 15.6464C16.5488 15.8417 16.5488 16.1583 16.3536 16.3536C16.1583 16.5488 15.8417 16.5488 15.6464 16.3536L12 12.7071L8.35355 16.3536C8.15829 16.5488 7.84171 16.5488 7.64645 16.3536C7.45118 16.1583 7.45118 15.8417 7.64645 15.6464L11.2929 12L7.64645 8.35355C7.45118 8.15829 7.45118 7.84171 7.64645 7.64645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3d21ed3391ab9a9c6624abbdebdcf498.svg";
export { ForwardRef as ReactComponent };